import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/ic-magnifying-glass-area-outline-white.svg")